export default Object.freeze(
    {
        /**
         * Limit above which the entities switcher shall display a search field
         * instead of listing all of the user's entities.
         */
        SWITCHER_THRESHOLD: 10,
    }
);
